module.exports = __webpack_public_path__ + "img/custom.91b54373.svg";